import React from 'react'

interface Props {
    value: number
    showIcon: boolean
    lessIsGood: boolean
    showValue: boolean
    color: boolean
    className?: string
}
class Tendency extends React.Component<Props> {
    public static defaultProps = {
        value: 0,
        showValue: true,
        showIcon: true,
        lessIsGood: true,
        color: true,
    }

    public getConfig = value => {
        if (value <= -0.3) {
            return {
                icon: 'fa fa-angle-double-down',
                text: 'Decreased by ',
                class: !this.props.lessIsGood ? 'double-down' : 'double-up',
                decimals: 0,
            }
        } else if (value <= -0.05) {
            return {
                icon: 'fa fa-angle-down',
                text: 'Decreased by ',
                class: !this.props.lessIsGood ? 'down' : 'up',
                decimals: 1,
            }
        } else if (value >= 0.3) {
            return {
                icon: 'fa fa-angle-double-up',
                text: 'Increased by ',
                class: !this.props.lessIsGood ? 'double-up' : 'double-down',
                decimals: 1,
            }
        } else if (value >= 0.05) {
            return {
                icon: 'fa fa-angle-up',
                text: 'Increased by ',
                class: !this.props.lessIsGood ? 'up' : 'down',
                decimals: 1,
            }
        }

        return {
            icon: 'fa fa-genderless',
            text: 'Roughly the same with ',
            class: 'text-muted',
            decimals: 1,
        }
    }

    public render() {
        const value = this.normalize(this.props.value)
        const config = this.getConfig(value)

        if (!value && this.props.showValue) {
            return <span className={'tendency'}>-</span>
        }

        if (!value) {
            return this.props.className ? (
                <span className={'text-muted fa fa-genderless ' + this.props.className} />
            ) : (
                <span className="text-muted fa fa-genderless" />
            )
        }

        if (!this.props.color) {
            config.class = ''
        }

        if (this.props.className) {
            config.class += ' ' + this.props.className
        }

        return (
            <span
                className={'tendency ' + config.class + ' tw-tooltip tw-tooltip-dataText tw-tooltip--right'}
                data-tooltip-text={config.text + (value * 100).toFixed(config.decimals) + '%'}
            >
                {!this.props.showValue ? null : (
                    <span>
                        {value > 0 ? '+' : null}
                        {(value * 100).toFixed(config.decimals)}%&nbsp;
                    </span>
                )}
                {this.props.showIcon ? <span className={config.icon} /> : null}
            </span>
        )
    }

    public normalize = value => {
        if (!isFinite(value)) {
            return 0
        }

        return value
    }
}

export default Tendency
